/*
 * @Description: 接口请求参数签名
 * @Author: mdb
 * @Date: 2022-06-08 15:09:18
 * @LastEditTime: 2022-08-03 10:16:34
 * @LastEditors: mdb
 */
import MD5 from 'md5.js'

/**
 * sign 字段  签名方法
 *
 * @param {*} obj
 * @param {string} [key='5d5abb75-3856-473c-8b56-cc49aa6e3c2h']
 * @return {*}
 */
const signatureFn = (obj: any, key = '5d5abb75-3856-473c-8b56-cc49aa6e3c2h') => {
  const arr = []
  let num = 0
  for (const i in obj) {
    // 剔除字段没有值的情况
    if (obj[i]) {
      arr[num] = i
      num++
    }
  }
  arr.sort()
  // 在最后加上secretKey
  arr.push('secretKey')
  obj.secretKey = key
  const strarr: string[] = []
  arr.forEach((k) => {
    if (typeof obj[k] !== 'object') {
      strarr.push(`${k}=${obj[k]}`)
    } else {
      strarr.push(`${k}=${JSON.stringify(obj[k])}`)
    }
  })
  const paseStr = new MD5().update(strarr.join('&')).digest('hex')
  return paseStr
}

export { signatureFn }
